import NotificationModal from '../NotificationModal/NotificationModal';
import { NOTIFICATION_MODAL } from '../../utils/constants/commonConstants';
import { TALK_TO_US_HEADER, TALK_TO_US_CONTENT } from './constants';
import { buildContactLine } from './talkToUsUtils';
import type { TalkToUsModalProps } from './types';

const TalkToUsModal = ({ isOpen, onClose, contactInput }: TalkToUsModalProps) =>
    isOpen ? (
        <NotificationModal
            isOpen={isOpen}
            onClose={onClose}
            position="top-right"
            header={TALK_TO_US_HEADER}
            content={TALK_TO_US_CONTENT}
            footer={
                <div>
                    <div>{buildContactLine(contactInput)}</div>
                </div>
            }
            source={NOTIFICATION_MODAL.CONTACT_US}
        />
    ) : null;

export default TalkToUsModal;
